/**
 * Save the section id to the history state
 * @param sectionId - The section id
 */
const setHistoryState = (sectionId: string) => {
  history.replaceState(
    null,
    '',
    `${window.location.pathname}${window.location.search}#${sectionId}-section`
  );
};

export default setHistoryState;
